import { Injectable } from "@angular/core";
import { ClientService } from "../../services/client.service";
import {
  Actions,
  createEffect,
  ofType
} from "@ngrx/effects";
import { ClientActions } from "./client.actions";
import { from, mergeMap, tap } from "rxjs";
import { Plan } from "../../class/plan.class";
import { ClientModel } from "../../models/client.model";
import { PlanModel } from "../../models/plan.model";

type ClientResponse = {
  id: number;
  email: string;
  active: boolean;
  username: string;
  pass: string;
  ref_token: string;
  google_id: string;
  avatar: string;
  stripe_id: string;
  updated_at: string;
  created_at: string;
  deleted_at: string | null;
  token_left: number;
  plan: PlanModel
};

@Injectable()
export class ClientEffect {
  constructor(
    private clientService: ClientService,
    private action$: Actions
  ) { }

  loadClient$ = createEffect(() =>
    this.action$.pipe(
      ofType(ClientActions.loadClient),
      mergeMap(() =>
        this.clientService.getClientData().pipe(
          mergeMap((meResponse: ClientResponse) => {
            const client: ClientModel = {
              id: meResponse.id,
              email: meResponse.email,
              username: meResponse.username,
              avatar: meResponse.avatar,
              created_at: new Date(meResponse.created_at),
              deleted_at: meResponse.deleted_at ? new Date(meResponse.deleted_at) : null,
              updated_at: meResponse.updated_at ? new Date(meResponse.updated_at) : null
            };
            const plan: PlanModel | undefined = meResponse.plan ? meResponse.plan : undefined;
            if (plan) {
              return from([
                ClientActions.loginClient({ client: client }),
                ClientActions.setTokens({ tokens: meResponse.token_left }),
                ClientActions.setTokensPerMonth({ tokens: plan.token_per_month }),
                ClientActions.setPlan({ plan: new Plan(plan) })
              ]);
            } else {
              return from([
                ClientActions.loginClient({ client: client }),
                ClientActions.setTokens({ tokens: meResponse.token_left })
              ]);
            }
          })
        )
      )
    )
  );
}